import { NavLink } from 'react-router-dom';
import { cn } from '~/lib/cn';

interface Tab {
  to: string;
  label: string;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: '/', label: 'Overview', end: true },
  { to: '/programs', label: 'Programs' },
  { to: '/accounts', label: 'Accounts' },
  { to: '/cardholders', label: 'Cardholders' },
  { to: '/cards', label: 'Cards' },
  { to: '/keys', label: 'Keys' },
  { to: '/webhooks', label: 'Webhooks' },
  { to: '/logs', label: 'Logs' },
];

/**
 * Secondary nav row under the top bar. One active indicator (a 1px line
 * under the current tab, same ink as text). No background pill, no color
 * — a Vercel-style tab strip.
 */
export function Tabs(): JSX.Element {
  return (
    <div className="sticky top-14 z-[9] -mt-px flex items-end gap-5 border-b border-rule-hairline bg-surface-canvas/85 px-10 pt-3 backdrop-blur-sm">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            cn(
              'relative pb-2.5 text-[14px] font-medium transition-colors',
              isActive
                ? 'text-ink-primary after:absolute after:inset-x-0 after:-bottom-px after:h-[2px] after:bg-ink-primary after:content-[""]'
                : 'text-ink-watermark hover:text-ink-primary',
            )
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
